import { Url } from 'next/dist/shared/lib/router/router';

import { TransformedUseCase } from '@editor/types';

import { UseCaseSelection } from '../../components/DesignsListPage/v1/type';

import { findUseCase } from './useCaseUtils';

export const ALL_SLUG = 'all';
export const TEMPLATES_PATH = '/templates';

export const DEFAULT_SELECTION: UseCaseSelection = {
  categorySlug: ALL_SLUG,
  subCategorySlug: ALL_SLUG,
  useCaseSlug: ALL_SLUG,
  subUseCaseSlug: ALL_SLUG,
};

export const buildTemplatesUrl = (
  category?: string,
  subcategory?: string,
  useCase?: string,
  subUseCase?: string
): Url => {
  let path = '';
  if (useCase && subUseCase) {
    path = `${useCase}/${subUseCase}`;
  } else if (useCase) {
    path = `${useCase}`;
  } else if (subUseCase) {
    path = `${ALL_SLUG}/${subUseCase}`;
  }

  return {
    pathname: `${TEMPLATES_PATH}/${path}`,
    query: {
      ...(category && category !== ALL_SLUG ? { category } : {}),
      ...(subcategory && subcategory !== ALL_SLUG ? { subcategory } : {}),
    },
  };
};

type Params = Record<string, string | string[] | undefined>;

export const getTemplatesUseCaseFromParams = (params?: Params | null) => {
  const [useCaseSlug, subUseCaseShortName] = params?.useCaseSlug || [];
  return {
    useCase: useCaseSlug || ALL_SLUG,
    subUseCase: subUseCaseShortName,
  };
};

export const getTemplatesSubCategoryFromUrlParams = (
  urlParams: URLSearchParams
) => {
  return urlParams?.get('subcategory') || ALL_SLUG;
};

export const getTemplatesCategoryFromUrlParams = (
  urlParams: URLSearchParams
) => {
  return urlParams?.get('category') || ALL_SLUG;
};

export const getCurrentSelection = (
  params: Params | null | undefined,
  urlSearchParams: URLSearchParams,
  allCategoriesAndUseCases: TransformedUseCase[]
): {
  categorySlug: string;
  subCategorySlug: string;
  useCaseSlug: string;
  subUseCaseSlug: string;
} => {
  const categorySlug = getTemplatesCategoryFromUrlParams(urlSearchParams);
  const subCategorySlug = getTemplatesSubCategoryFromUrlParams(urlSearchParams);

  const { useCase: useCaseSlug, subUseCase: subUseCaseShortName } =
    getTemplatesUseCaseFromParams(params);

  const currentUseCaseData = findUseCase(allCategoriesAndUseCases, useCaseSlug);

  const currentSubUseCaseData = currentUseCaseData?.subUseCases?.find(
    (subUseCase) => subUseCase.shortName === subUseCaseShortName
  );

  const subUseCaseSlug = currentSubUseCaseData?.slug ?? ALL_SLUG;

  return {
    categorySlug,
    subCategorySlug,
    useCaseSlug,
    subUseCaseSlug,
  };
};

export function findActiveTemplateParam(
  currentSubUseCaseSlug = '',
  currentUseCaseSlug = '',
  currentSubCategorySlug = '',
  currentCategorySlug = ''
) {
  return [
    currentSubUseCaseSlug,
    currentUseCaseSlug,
    currentSubCategorySlug,
    currentCategorySlug,
  ]
    .filter((slug) => slug !== ALL_SLUG)
    .find(Boolean);
}
